@for (message of messages$ | async; track message.id) {
  <div class="modal-backdrop">
    <div class="modal-dialog" [class]="'modal-dialog--' + message.type">
      <div class="modal-header">
        @if (message.type !== 'info') {
          <div class="modal-icon">
            <fa-icon [icon]="getIcon(message.type)" size="2x"></fa-icon>
          </div>
        }
        <button class="modal-close" (click)="dismiss(message.id)" aria-label="Cerrar">
          <fa-icon [icon]="faXmark"></fa-icon>
        </button>
      </div>
      <div class="modal-body">
        <h3 class="modal-title">{{ getTitle(message.type) }}</h3>
        <p class="modal-message" [innerHTML]="message.message"></p>
      </div>
      <div class="modal-footer">
        <button class="app-btn app-btn--primary" (click)="dismiss(message.id)">Aceptar</button>
      </div>
    </div>
  </div>
}
